import styled from "styled-components";

export const BasketContainer = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;

	h5 {
		margin-bottom: 1.6rem;

		@media only screen and (min-width: ${props => props.theme.desktop}) {
			margin-bottom: 2.4rem;
		}
	}
`;

export const BasketTabs = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const BasketHeader = styled.div`
	background-color: ${props => props.theme.darkerGreen};
	padding-left: 2.4rem;
	padding-right: 2.4rem;
	border-top-left-radius: 0.5rem;
	border-top-right-radius: 0.5rem;

	span {
		border-radius: 0.5rem;
		padding: 0.2rem 0.8rem;
		background-color: ${props => props.theme.mintGreen};
		color: ${props => props.theme.darkGreen};
		margin-left: 1.6rem;
	}

	button {
		color: #ffffff70;
		font-size: 1.4rem;
		padding: 1.6rem 0;
		font-weight: 900;

		&[aria-selected='true'] {
			color: ${props => props.theme.white};
			position: relative;

			&:after {
				content: "";
				position: absolute;
				border-bottom: 0.2rem solid ${props => props.theme.darkYellow};
				width: 100%;
				bottom: 0;
				left: 0;
			}

			span {
				background-color: ${props => props.theme.darkYellow};
				color: ${props => props.theme.black};
			}
		}

		&:not(:first-child) {
			margin-left: 4.8rem;

			@media only screen and (min-width: ${props => props.theme.desktop}) {
				margin-left: 6.4rem;
			}
		}

		@media only screen and (min-width: ${props => props.theme.desktop}) {
			font-size: 1.8rem;
			padding: 1.6rem;
		}
	}
`;

export const BasketPanel = styled.div`
	display: block;
	overflow-y: auto;
	border: ${props => props.theme.midGreyBorder};
	border-bottom-left-radius: 0.5rem;
	border-bottom-right-radius: 0.5rem;
	flex-grow: 1;
	max-height: 60rem;

	&.basket-summary-shop-panel {
		table {
			tr {
				&:nth-last-child(2) {
					border: none;

					td {
						padding-bottom: 0.5rem;
					}
				}

				&:last-child {
					td {
						padding-top: 0;
					}
				}
			}
		}
	}

	table {
		padding: 2.4rem;
		width: 100%;
		display: block;
		overflow-y: auto;
		margin: 0;

		thead {
			tr {
				border: none;
			}

			th {
				padding-top: 0;
				padding-bottom: 0.8rem;

				:nth-of-type(2) {
					text-align: right;
				}
			}
		}

		tr {
			border-color: #CFD0CF !important;
			table-layout: fixed;
			width: 100%;
			display: table;
			border-top: none;

			&:last-child {
				border: none;
			}
			
			td:nth-child(2) {
				text-align: right;
			}
		}

		tr, td {
			background-color: transparent !important;
		}

		th, td {
			width: auto !important;
			height: auto !important;
			padding: 0.8rem 0;

			&:after {
				content: none !important;
			}

			&:last-child {
				text-align: right;
				padding-right: 0;
			}

			@media only screen and (min-width: ${props => props.theme.desktop}) {
				padding-top: 1.6rem;
				padding-bottom: 1.6rem;
				padding-right: 1.6rem;
			}
		}
	}
`;


export const BasketTotal = styled.div`
	border-top: ${props => props.theme.midGreyBorder};
	border-bottom: ${props => props.theme.midGreyBorder};
	padding: 2.4rem;

	span {
		font-size: 1.8rem;
		font-weight: 700;
		border-bottom: none;
		font-family: ${props => props.theme.fontBold};
	}

	div {
		display: flex;
		justify-content: space-between;
	}

	@media only screen and (max-width: 1199px) {
		padding-bottom: 0;
	}

	.bn {
		width: 100%;
		margin-top: 2.4rem;
	}
`;

export const BasketEmpty = styled.div`
	padding-top: 2.4rem;

	> div {
		border-bottom: ${props => props.theme.midGreyBorder};
		padding-right: 2.4rem;
		padding-left: 2.4rem;
		padding-bottom: 2rem;

		> p {
			font-size: 1.8rem;
			font-weight: 700;
			border-bottom: none;
			font-family: ${props => props.theme.fontBold};
			margin-bottom: 0;
		}
	}

	ul {
		margin-bottom: 0;
		padding-left: 0;

		li {
			margin: 0.6rem 0;
			
			&:before {
				content: none;
			}

			a  {
				text-decoration: none;
			}
		}
	}

	> .bn {
		margin-left: 2.4rem;
		margin-right: 2.4rem;
		margin-top: 2.4rem;
		width: calc(100% - 4.8rem);
	}
`;
